module.exports = __webpack_public_path__ + "img/button-left-plus.c3b0ed25.png";